/**
 * The company's social accounts, in the order they are shown site-wide.
 *
 * The two icon sets are the same marks in different colours: the footer and the
 * mobile drawer sit on dark backgrounds, the media page on light. Keeping both
 * here means a new account or a changed handle is a one-line edit.
 */
export const socialLinks = [
  {
    label: "YouTube",
    href: "https://www.youtube.com/@quantstamp",
    lightIcon: "/images/white-youtube-logo.svg",
    darkIcon: "/images/black-youtube-logo.svg",
  },
  {
    label: "GitHub",
    href: "https://github.com/quantstamp",
    lightIcon: "/images/white-github-logo.svg",
    darkIcon: "/images/black-github-logo.svg",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/quantstamp/",
    lightIcon: "/images/white-linkedin-logo.svg",
    darkIcon: "/images/black-linkedin-logo.svg",
  },
  {
    label: "X",
    href: "https://x.com/Quantstamp",
    lightIcon: "/images/white-twitter-logo.svg",
    darkIcon: "/images/black-twitter-logo.svg",
  },
] as const;
